import { ApiAccountDashboardPortfolios } from 'api/rtk-api'
import { FofPortfolioModal, ModelPortfolioModal, ValueCountPoint } from 'components/core-v2'

export const formatData = (data: ApiAccountDashboardPortfolios) => {
  const innerDataPoints: ValueCountPoint[] = [
    {
      name: 'Model',
      id: 'model',
      parent: '0',
      ModalComponent: ModelPortfolioModal
    },
    {
      name: 'Self select',
      id: 'self',
      parent: '0'
    },
    {
      name: 'Fund of fund',
      id: 'fof',
      parent: '0',
      ModalComponent: FofPortfolioModal
    }
  ]
  const modelDataPoints: ValueCountPoint[] = data.model.portfolios.map(portfolio => ({
    // This is a temporary measure due to Dominion trades not having a portfolio id or name
    name: portfolio.portfolioName || 'Dominion Growth Portfolio',
    id: portfolio.portfolioId || 'dominion-growth-portfolio',
    parent: 'model',
    value: portfolio.zarValue
  }))
  const fofDataPoints: ValueCountPoint[] = data.fundOfFunds.portfolios.map(portfolio => ({
    // This is a temporary measure due to Dominion trades not having a portfolio id or name
    name: portfolio.portfolioName || 'Dominion Growth Portfolio',
    id: portfolio.portfolioId || 'dominion-growth-portfolio',
    parent: 'fof',
    value: portfolio.zarValue
  }))
  const selfSelectDataPoints: ValueCountPoint[] = data.selfSelect.portfolios.map(
    (portfolio, index) => ({
      name: 'Self select',
      id: `self-${index}`,
      parent: 'self',
      value: portfolio.zarValue
    })
  )

  return [...innerDataPoints, ...modelDataPoints, ...fofDataPoints, ...selfSelectDataPoints]
}
